// reducer.js
import * as actionTypes from "./actionsTypes";

const initialState = {
  currentPage: 1,
  value: "",
  sansEmail: false,
  enAttenteValidation: false,
  statut: "",
  type: "",
  compteOuvert: "",
  courrier: "",
  creeLe: "",
  derniereSouscription: "",
  selectedOptions: [],
  sortField: "nom_investisseur",
  order: "asc",
};

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_VALUE:
      return {
        ...state,
        value: action.payload,
      };
    case actionTypes.SET_CURRENT_PAGE:
      return {
        ...state,
        currentPage: action.payload,
      };
    case actionTypes.SET_SANS_EMAIL:
      return {
        ...state,
        sansEmail: action.payload,
      };
    case actionTypes.SET_EN_ATTENTE_VALIDATION:
      return {
        ...state,
        enAttenteValidation: action.payload,
      };
    case actionTypes.SET_STATUT:
      return {
        ...state,
        statut: action.payload,
      };
    case actionTypes.SET_TYPE:
      return {
        ...state,
        type: action.payload,
      };
    case actionTypes.SET_COMPTE_OUVERT:
      return {
        ...state,
        compteOuvert: action.payload,
      };
    case actionTypes.SET_COURRIER:
      return {
        ...state,
        courrier: action.payload,
      };
    case actionTypes.SET_CREE_LE:
      return {
        ...state,
        creeLe: action.payload,
      };
    case actionTypes.SET_DERNIERE_SOUSCRIPTION:
      return {
        ...state,
        derniereSouscription: action.payload,
      };
    case actionTypes.SET_SELECTED_OPTIONS:
      return {
        ...state,
        selectedOptions: action.payload,
      };
    case actionTypes.SET_SORT_FIELD:
      return {
        ...state,
        sortField: action.payload,
      };
    case actionTypes.SET_ORDER:
      return {
        ...state,
        order: action.payload,
      };
    default:
      return state;
  }
};

export default rootReducer;
